<mat-toolbar test-id="notification-bar" color="primary" style="min-height: 48px">
  <mat-toolbar-row style="height: 48px">
    <button test-id="show-navigation" mat-icon-button (click)="toggleSidenav.emit()"><mat-icon>menu</mat-icon></button>
    <div class="flex-stretch flex-align-center">
      <span test-id="navigation-bar-title" [style.font-size]="'large'">{{ componentCommunication.currentRouteTitle | async }}</span>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
